import Utils from '@/utils/util';
import { CashPaymentOption } from '../types';
import './PaymentOptionCard.scss';
import { ReactComponent as RadioSelected } from '@/assets/img/select-radio.svg';
import { ReactComponent as RadioDeselected } from '@/assets/img/deselect-radio.svg';

export type PaymentOptionCardProps = {
  data: CashPaymentOption;
  isSelected: boolean;
  onSelect: (option: CashPaymentOption) => void;
};

export const PaymentOptionCard = ({ data, isSelected, onSelect }: PaymentOptionCardProps) => {
  const onServiceSelected = () => {
    onSelect(data);
  };
  return (
    <div className="payment-options-card" onClick={onServiceSelected}>
      <div className="left-section">
        <img src={data.icon} />
        <div className="details">
          <p className="name">{data.label}</p>
          {/* <p className="description">{data.description}</p> */}
        </div>
      </div>
      {isSelected ? <RadioSelected /> : <RadioDeselected />}
    </div>
  );
};

PaymentOptionCard.displayName = 'Room Card';
